// extracted by mini-css-extract-plugin
module.exports = {"trigger":"AnimationsPaneTrigger_trigger__35_e7","triggerActive":"AnimationsPaneTrigger_triggerActive__1CDUA"};